import api from "../utils/api";

// GET /api/tickets
export async function getTickets() {
  const res = await api.get("/tickets");
  return res.data?.tickets || [];
}

// POST /api/tickets
export async function createTicket(payload) {
  const res = await api.post("/tickets", payload);
  return res.data;
}

// PATCH /api/tickets/:id
export async function updateTicket(id, payload) {
  const res = await api.patch(`/tickets/${id}`, payload);
  return res.data;
}

// DELETE /api/tickets/:id
export async function deleteTicket(id) {
  const res = await api.delete(`/tickets/${id}`);
  return res.data;
}

// GET /api/tickets/:id
export async function getTicketDetail(id) {
  const res = await api.get(`/tickets/${id}`);
  return res.data; // { ticket, messages }
}

// POST /api/tickets/:id/messages
export async function addTicketMessage(id, payload) {
  const res = await api.post(`/tickets/${id}/messages`, payload);
  return res.data;
}